export const rcsErrorCodeSummary = (builder) => ({
    rcsErrorCodeSummary: builder.mutation({
        query: ({ page, limit, code, search, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_RCS_API_PORT + '/rcs_error_code_summary',
                method: 'GET',
                params: { page, limit, code, search, startDate, endDate  },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});